const MAX_AUTHOR_WIDTH = 200
const DEFAULT_AUTHOR_WIDTH = 168
const DEFAULT_ASPECT_RATIO = 1

export function useAuthorImageStyle () {
  const getAuthorImageStyle = (author) => {
    if (author?.imageCropDimensions) {
      const { width, height } = author.imageCropDimensions
      if (width === 0 || height === 0) {
        return {
          aspectRatio: `${DEFAULT_ASPECT_RATIO}`,
          objectFit: 'cover',
          objectPosition: 'center center'
        }
      }
      const aspectRatio = width / height
      return {
        aspectRatio: `${aspectRatio}`,
        objectFit: 'cover',
        objectPosition: 'center center'
      }
    }
    return {
      aspectRatio: `${DEFAULT_ASPECT_RATIO}`,
      objectFit: 'cover',
      objectPosition: 'center center'
    }
  }

  const getAuthorImageContainerStyle = (author, maxWidth = null) => {
    const effectiveMaxWidth = maxWidth || MAX_AUTHOR_WIDTH
    
    if (author?.imageCropDimensions) {
      const { width, height } = author.imageCropDimensions
      if (width === 0 || height === 0) {
        return {
          width: '100%',
          maxWidth: `${effectiveMaxWidth}px`,
          aspectRatio: `${DEFAULT_ASPECT_RATIO}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }
      }

      const aspectRatio = width / height
      let displayWidth = width
      let displayHeight = height

      if (width > effectiveMaxWidth) {
        const scale = effectiveMaxWidth / width
        displayWidth = effectiveMaxWidth
        displayHeight = height * scale
      }

      return {
        width: '100%',
        maxWidth: `${displayWidth}px`,
        height: `${displayHeight}px`,
        aspectRatio: `${aspectRatio}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }
    }
    return {
      width: '100%',
      maxWidth: `${effectiveMaxWidth}px`,
      aspectRatio: `${DEFAULT_ASPECT_RATIO}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }
  }

  return {
    getAuthorImageStyle,
    getAuthorImageContainerStyle,
    MAX_AUTHOR_WIDTH,
    DEFAULT_AUTHOR_WIDTH
  }
}

